<fgb-banner [pageTitle]="'games.page.title' | translate" *notInPopulation="[populations.Kids]" />
<ng-container *inPopulation="[populations.Kids]">
  <div class="img-banner-container d-none d-lg-block" role="banner">
    <div class="container">
      <img [src]="'banner-images/games-banner-desktop.png' | contentAssetImage" alt="kid banner" class="w-100" />
    </div>
  </div>
</ng-container>
<div class="d-lg-none">
  <fgb-page-header [pageTitle]="'games.page.title'"  [showFooter]="true" [backButtonLink]="'/'" />
</div>
<div class="container margin-30">
  <div class="game-container-sections row">
    <div class="col-12 col-lg-6">
      <img alt="trivia" [src]="'games/trivia.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-uppercase font-size-20 fw-bold">{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/trivia'">
          <div class="btn">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <img alt="polls" [src]="'games/polls.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-uppercase font-size-20 fw-bold">{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <img alt="predictor" [src]="'games/predictor.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-uppercase font-size-20 fw-bold">{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
